import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-568bf530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-body" }
const _hoisted_2 = { class: "item-title" }
const _hoisted_3 = { class: "item-title-inner" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_picklist_progress = _resolveComponent("picklist-progress")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.detail(_ctx.picklist))),
    class: "picklist-item py-5"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_list_item_title, { class: "text-truncate max-width-text" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.picklist.Tour, (tour) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: tour.Tournr
                  }, _toDisplayString(tour.KfzKennzeichen), 1))
                }), 128)),
                (!_ctx.picklist.Tour.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.picklist.allPositions[0].Name), 1))
                  : _createCommentVNode("", true)
              ], undefined, true),
              _: 1
            }),
            (!_ctx.picklist.Tour.length)
              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.picklist.allPositions[0].Belegnr), 1)
                  ], undefined, true),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_v_list_item_subtitle, null, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.picklist.ErstelltamDate) + " " + _toDisplayString(_ctx.picklist.ErstelltamTime), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("small", null, "#" + _toDisplayString(_ctx.picklist.Picklistnr), 1)
                ])
              ], undefined, true),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(_component_picklist_progress, { picklist: _ctx.picklist }, null, 8, ["picklist"])
    ], undefined, true),
    _: 1
  }))
}